import React from 'react';
import { motion } from 'framer-motion';
export function ProductPresentation() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-16 px-4 bg-white" data-id="element-376">
      <div className="max-w-lg md:max-w-3xl mx-auto" data-id="element-377">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-[#FFF8F0] rounded-3xl p-8 md:p-12 shadow-sm border border-[#FFE0B2]" data-id="element-378">
          <div className="text-center mb-10" data-id="element-379">
            <span className="text-5xl mb-4 block" data-id="element-380">🥦</span>
            <h2 className="text-4xl md:text-5xl font-black text-[#2E7D32] mb-4 tracking-tight" data-id="element-381">
              NUTRIPEQUES
            </h2>
            <p className="text-xl md:text-2xl font-bold text-gray-700 italic" data-id="element-382">
              Guía práctica de alimentación infantil sin estrés
            </p>
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-sm mb-10 text-center" data-id="element-383">
            <p className="text-lg text-gray-700 font-medium" data-id="element-384">
              NutriPeques es el sistema de alimentación infantil pensado para
              madres reales, con días largos y tiempos limitados.
            </p>
          </div>

          <div className="space-y-6 text-gray-700 text-lg mb-12" data-id="element-385">
            <p data-id="element-386">No es un libro de recetas más.</p>
            <p data-id="element-387">
              Es un sistema completo que combina educación simple, organización
              práctica y 60 recetas reales para niños de 1 a 7 años.
            </p>
            <p className="font-bold text-[#FF8A65]" data-id="element-388">
              Para que la hora de comer pase de ser una batalla a un momento de
              calma.
            </p>
          </div>

          <div className="border-t border-[#FFE0B2] pt-10 mb-10" data-id="element-389">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-390">
              EL ORIGEN
            </h3>
            <p className="text-gray-700 text-lg mb-6" data-id="element-391">
              Este libro nació de algo muy simple: el agotamiento real de madres
              que querían hacer las cosas bien y no sabían por dónde empezar.
            </p>
            <p className="text-gray-700 text-lg mb-8" data-id="element-392">
              No de un laboratorio. No de una teoría académica. De la cocina
              real, con ingredientes accesibles, con niños que rechazan el
              brócoli y que solo quieren pasta.
            </p>

            <div className="bg-[#E8F5E9] p-6 rounded-2xl text-center border border-[#C8E6C9]" data-id="element-393">
              <p className="text-sm text-[#2E7D32] font-bold uppercase tracking-wider mb-2" data-id="element-394">
                La pregunta clave
              </p>
              <p className="text-xl font-bold text-gray-900 italic" data-id="element-395">
                "¿Qué necesita saber una mamá —no una nutricionista— para
                alimentar bien a su hijo sin volverse loca?"
              </p>
            </div>
            <p className="text-center text-gray-600 mt-4 italic" data-id="element-396">
              Y la respuesta resultó ser más simple de lo que cualquiera
              imaginaba.
            </p>
          </div>

          <div className="flex flex-col items-center" data-id="element-397">
            <img src="https://cdn.magicpatterns.com/uploads/wkzGFuHWyP7z23EbiJvcUP/heylloyd-image-1772533088855.png" alt="NutriPeques Guía" className="w-48 md:w-64 h-auto rounded-xl shadow-lg mb-8" data-id="element-398" />
            <button onClick={scrollToOffer} className="w-full md:w-auto min-h-[64px] bg-[#2E7D32] hover:bg-[#1B5E20] text-white text-lg md:text-xl font-bold rounded-2xl shadow-[0_6px_0_#1B5E20] hover:shadow-[0_3px_0_#1B5E20] hover:translate-y-1 transition-all px-8 py-4" data-id="element-399">
              Quiero que la mesa deje de ser una batalla
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}